import { render, staticRenderFns } from "./pluginRedirect.vue?vue&type=template&id=97141f60&scoped=true&"
import script from "./pluginRedirect.vue?vue&type=script&lang=js&"
export * from "./pluginRedirect.vue?vue&type=script&lang=js&"
import style0 from "./pluginRedirect.vue?vue&type=style&index=0&id=97141f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97141f60",
  null
  
)

export default component.exports